/**
 * Convert simple boolean block conditions to Formly hideExpression
 * Handles: checkbox, file-upload blocks
 */

export interface SimpleConditionProps {
	checked?: boolean; // For checkbox-condition
	isUploaded?: boolean; // For file-upload-condition
}

/**
 * Convert a simple boolean condition to hideExpression
 * Returns expression that evaluates to TRUE when condition is MET
 * (Remember: hideExpression hides when TRUE, so we'll invert later)
 */
export function convertSimpleCondition(
	fieldKey: string,
	props: SimpleConditionProps,
	conditionType: string
): string | undefined {
	switch (conditionType) {
		case 'checkbox-condition':
			// Check if checkbox is checked or unchecked
			if (props.checked === true) {
				// Condition met when checkbox IS checked
				return `model['${fieldKey}'] === true`;
			} else if (props.checked === false) {
				// Condition met when checkbox is NOT checked
				return `model['${fieldKey}'] !== true`;
			}
			return undefined;

		case 'file-upload-condition':
			// Check if file is uploaded or not uploaded
			if (props.isUploaded === true) {
				// Condition met when file IS uploaded (has value)
				return `!!(model['${fieldKey}'] && model['${fieldKey}'] !== '')`;
			} else if (props.isUploaded === false) {
				// Condition met when file is NOT uploaded (no value)
				return `!(model['${fieldKey}'] && model['${fieldKey}'] !== '')`;
			}
			return undefined;

		default:
			return undefined;
	}
}
